<template>
  <div
    class="modal fade"
    id="addChecksFurtherSettingsModal"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            aria-hidden="true"
            @click="closeModal()"
          >
            ×
          </button>
          <h4 class="modal-title">{{ lang.CFM000 }}</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="col-md-3 control-label"></label>
            <div class="col-md-9">
              <div class="checkbox" style="float: left">
                <label>
                  <input type="checkbox" v-model="settings.OnlineState" />
                  <span class="checkbox-material">
                    <span class="check"></span>
                  </span>
                  <span class="text">{{ lang.CFM001 }}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-md-3 control-label"></label>
            <div class="col-md-9">
              <div class="checkbox" style="float: left">
                <label>
                  <input type="checkbox" v-model="settings.LocationFree" />
                  <span class="checkbox-material">
                    <span class="check"></span>
                  </span>
                  <span class="text">{{ lang.CFM002 }}</span>
                </label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label
              for="inputFurtherSettingsStartDate"
              class="col-md-3 control-label"
              >{{ lang.CFM003 }}</label
            >
            <div
              class="col-md-9"
              @click="globals.toggleFlatpickr('inputFurtherSettingsStartDate')"
            >
              <input
                type="text"
                class="form-control"
                id="inputFurtherSettingsStartDate"
                v-model="settings.SurveyInstanceSince"
              />
            </div>
          </div>
          <div class="form-group">
            <label
              for="inputFurtherSettingsEndDate"
              class="col-md-3 control-label"
              >{{ lang.CFM004 }}</label
            >
            <div
              class="col-md-9"
              @click="globals.toggleFlatpickr('inputFurtherSettingsEndDate')"
            >
              <input
                type="text"
                class="form-control"
                id="inputFurtherSettingsEndDate"
                v-model="settings.SurveyInstanceUntil"
              />
            </div>
          </div>
          <div class="form-group">
            <label
              for="inputFurtherSettingsBasePayment"
              class="col-md-3 control-label"
              >{{ lang.CFM005 }}</label
            >
            <div class="col-md-9">
              <currency-input
                id="inputFurtherSettingsBasePayment"
                class="form-control"
                v-model="settings.SurveyInstanceBasePayment"
                currency="EUR"
                :min="0"
                :locale="globals.currentLocale"
              ></currency-input>
            </div>
          </div>
          <div class="form-group">
            <label
              for="inputFurtherSettingsPlusPayment"
              class="col-md-3 control-label"
              >{{ lang.CFM006 }}</label
            >
            <div class="col-md-9">
              <currency-input
                id="inputFurtherSettingsPlusPayment"
                class="form-control"
                v-model="settings.SurveyInstancePlusPayment"
                currency="EUR"
                :min="0"
                :locale="globals.currentLocale"
              ></currency-input>
            </div>
          </div>
          <div class="form-group">
            <label class="col-md-3 control-label">{{ lang.CFM007 }}</label>
            <div class="col-md-9">
              <label class="form-control text-left">{{
                globals.getCurrencyString(totalPayment, "EUR")
              }}</label>
            </div>
          </div>
          <div class="form-group">
            <label
              for="selectSurveyInstanceSkillLevel"
              class="col-md-3 control-label"
              >{{ lang.CFM013 }}</label
            >
            <div class="col-md-9">
              <select
                class="form-control"
                id="selectSurveyInstanceSkillLevel"
                v-model.number="settings.SurveyInstanceSkillLevel"
              >
                <option value="0">
                  {{ lang.CFM018 }}
                  <span v-if="survey.SurveySkillLevel > 0"
                    >({{ survey.SurveySkillLevel }})</span
                  >
                </option>
                <option v-for="i in 5" :key="i">{{ i }}</option>
              </select>
            </div>
            <b-tooltip
              target="selectSurveyInstanceSkillLevel"
              :delay="globals.tooltipDelay"
              placement="right"
              boundary="viewport"
            >
              1 &rarr; {{ lang.CFM015 }}
              <br />
              <br />...
              <br />
              <br />
              5 &rarr; {{ lang.CFM016 }}
            </b-tooltip>
          </div>
          <div class="form-group">
            <label class="col-md-3 control-label"></label>
            <div class="col-md-9">
              <button
                type="button"
                class="btn btn-raised pull-left"
                @click="openHtmlEditor()"
              >
                {{ lang.CFM008 }}
              </button>
            </div>
          </div>
          <div class="form-group">
            <label class="col-md-3 control-label"></label>
            <div class="col-md-9">
              <button
                type="button"
                class="btn btn-raised pull-left"
                @click="openShopperFilterModal()"
              >
                {{ lang.CFM012 }}
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-raised pull-left"
            @click="clearSettings()"
          >
            {{ lang.CFM009 }}
          </button>
          <button type="button" class="btn btn-raised" @click="closeModal()">
            {{ lang.CFM010 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddChecksFurtherSettingsModal",
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    survey: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      settings: {
        SurveyInstanceSince: "",
        SurveyInstanceUntil: "",
        SurveyInstanceBasePayment: 0,
        SurveyInstancePlusPayment: 0,
        SurveyInstanceSkillLevel: 0,
        SurveyInstanceDescription: "",
        OnlineState: false,
        LocationFree: false,
        ShopperFilter: {},
      },
      fpBegin: null,
      fpEnd: null,
      lang: {
        CFM000: "Offer details",
        CFM001: "Online",
        CFM002: "Location free",
        CFM003: "Begin",
        CFM004: "End",
        CFM005: "Payment",
        CFM006: "Addition",
        CFM007: "Total",
        CFM008: "Edit offer description",
        CFM009: "Reset",
        CFM010: "Close",
        CFM011: "Offer description",
        CFM012: "Shopper Filter",
        CFM013: "Difficulty",
        CFM014: "inherit from survey",
        CFM015: "simple",
        CFM016: "difficult",
        CFM017: "End date before start date",
        CFM018: "Inherit from survey",
      },
    };
  },
  computed: {
    totalPayment() {
      return (
        this.settings.SurveyInstanceBasePayment +
        this.settings.SurveyInstancePlusPayment
      );
    },
  },
  watch: {
    showModal(newValue) {
      if (newValue) this.openModal();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#addChecksFurtherSettingsModal").on("hide.bs.modal", (e) =>
      this.$emit("closeModal")
    );
    $("#addChecksFurtherSettingsModal").on("hidden.bs.modal", (e) => {
      this.$emit("modalClosed", this.settings);
    });

    this.fpBegin = flatpickr(
      "#inputFurtherSettingsStartDate",
      this.globals.flatpickrDateConfig
    );
    this.fpEnd = flatpickr(
      "#inputFurtherSettingsEndDate",
      this.globals.flatpickrDateConfig
    );
  },
  destroyed() {
    if (this.fpBegin) this.fpBegin.destroy();
    if (this.fpEnd) this.fpEnd.destroy();
  },
  methods: {
    openModal() {
      this.globals.$on("getDataFromHtmlEditorModal", (data) => {
        this.settings.SurveyInstanceDescription = data;
      });
      this.globals.$on("getDataFromShopperFilterModal", (data) => {
        this.settings.ShopperFilter = data;
      });
      $("#addChecksFurtherSettingsModal").modal("show");
    },
    closeModal() {
      if (
        this.settings.SurveyInstanceSince &&
        this.settings.SurveyInstanceUntil &&
        this.settings.SurveyInstanceSince > this.settings.SurveyInstanceUntil
      ) {
        this.globals.showErrorSnackbar(this.lang.CFM017);
        return;
      }

      this.globals.$off("getDataFromHtmlEditorModal");
      this.globals.$off("getDataFromShopperFilterModal");
      $("#addChecksFurtherSettingsModal").modal("hide");
    },
    openHtmlEditor() {
      this.globals.$emit("openHtmlEditorModal");
      this.globals.$emit("sendDataToHtmlEditorModal", {
        title: this.lang.CFM011,
        content: this.settings.SurveyInstanceDescription,
      });
    },
    openShopperFilterModal() {
      this.globals.$emit("openShopperFilterModal");
      this.globals.$emit(
        "sendDataToShopperFilterModal",
        this.settings.ShopperFilter
      );
    },
    clearSettings() {
      this.fpBegin.clear();
      this.fpEnd.clear();
      this.settings = {
        SurveyInstanceSince: "",
        SurveyInstanceUntil: "",
        SurveyInstanceBasePayment: 0,
        SurveyInstancePlusPayment: 0,
        SurveyInstanceSkillLevel: 0,
        SurveyInstanceDescription: "",
        OnlineState: false,
        LocationFree: false,
        ShopperFilter: {},
      };
    },
  },
};
</script>

<style scoped>
.primary-border {
  border: 2px solid #ddd;
  border-radius: 10px;
  padding: 0 5px;
}
.form-group.is-focused > .primary-border {
  border-color: var(--color-primary-input);
}

.form-group {
  overflow: hidden;
}

.modal-footer > button.pull-left:first-child {
  margin-left: 5px;
}

.checkbox span.text {
  position: relative;
  top: 2px;
  left: 2px;
  color: #555;
}
</style>



// WEBPACK FOOTER //
// AddChecksFurtherSettingsModal.vue?30f244bd